module.exports = __webpack_public_path__ + "static/skillset-7610522edc6d7c4723adc423ccc71ebe.png";